class OtpDetails {
    otp = "";
}

export default OtpDetails;